(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-home"]) return;
  try {
    
document.querySelectorAll('.lb-mobile-menu a').forEach(function(link){link.addEventListener('click',function(){link.closest('details').removeAttribute('open')})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-horizon"]) return;
  try {
    
document.querySelectorAll('.lb-mobile-menu a').forEach(function(link){link.addEventListener('click',function(){link.closest('details').removeAttribute('open')})});
document.querySelectorAll('[data-recruit-role]').forEach(function(link){link.addEventListener('click',function(){var role=document.getElementById('lb-role');if(role){role.value=link.dataset.recruitRole;role.dispatchEvent(new Event('change',{bubbles:true}))}})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-video"]) return;
  try {
    
(function(){
  function mount(scope){
    scope.querySelectorAll('[data-lb-video]').forEach(function(root){
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      var dialog=root.querySelector('dialog');
      var launch=root.querySelector('[data-lb-video-open]');
      var start=root.querySelector('[data-lb-video-start]');
      var stage=root.querySelector('[data-lb-video-stage]');
      var status=root.querySelector('[data-lb-video-status]');
      var timer=null;
      function clear(){
        clearTimeout(timer);
        stage.replaceChildren();
        stage.hidden=true;
        start.hidden=false;
        start.disabled=false;
        status.textContent='';
      }
      launch.addEventListener('click',function(){dialog.showModal();});
      root.querySelector('[data-lb-video-close]').addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('close',function(){clear();launch.focus();});
      root.querySelector('[data-lb-video-fallback]').addEventListener('click',function(){
        dialog.close();
        var panel=document.querySelector('[data-lb-voice] details');
        if(panel&&!panel.closest('[data-lb-voice]').hidden){panel.open=true;panel.querySelector('summary').focus();}
      });
      start.addEventListener('click',function(){
        if(start.disabled)return;
        start.disabled=true;
        status.textContent=root.dataset.loading;
        try{
          var url=new URL(root.dataset.embedUrl);
          if(url.origin!=='https://embed.liveavatar.com'||url.username||url.password||!/^\/v1\/[a-z0-9-]+\/?$/i.test(url.pathname))throw new Error('Invalid embed');
          var frame=document.createElement('iframe');
          frame.title=root.dataset.frameTitle;
          frame.allow='microphone';
          frame.referrerPolicy='strict-origin-when-cross-origin';
          frame.src=url.href;
          frame.addEventListener('load',function(){
            if(!dialog.open||!stage.contains(frame))return;
            clearTimeout(timer);
            status.textContent=root.dataset.loaded;
          },{once:true});
          frame.addEventListener('error',function(){
            clear();
            status.textContent=root.dataset.error;
          },{once:true});
          stage.replaceChildren(frame);
          stage.hidden=false;
          start.hidden=true;
          timer=setTimeout(function(){if(dialog.open)status.textContent=root.dataset.error;},15000);
        }catch(error){
          clear();
          status.textContent=root.dataset.error;
        }
      });
      root._lbVideoCleanup=clear;
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){mount(document);},{once:true});}else{mount(document);}
  document.addEventListener('shopify:section:load',function(event){mount(event.target);});
  document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-lb-video]').forEach(function(root){if(root._lbVideoCleanup)root._lbVideoCleanup();});});
  window.addEventListener('pagehide',function(){document.querySelectorAll('[data-lb-video]').forEach(function(root){if(root._lbVideoCleanup)root._lbVideoCleanup();});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-voice"]) return;
  try {
    
(function(){
  function mount(scope){
    scope.querySelectorAll('[data-lb-voice]').forEach(function(root){
      if(root.dataset.ready)return;
      root.dataset.ready='true';
      var button=root.querySelector('[data-lb-voice-load]');
      var status=root.querySelector('[data-lb-voice-status]');
      button.addEventListener('click',function(){
        if(button.disabled)return;
        button.disabled=true;
        status.textContent=root.dataset.loading;
        var settled=false;
        var timeout;
        var script=document.getElementById('lb-elevenlabs-script');
        function fail(){
          if(settled)return;
          settled=true;
          clearTimeout(timeout);
          button.disabled=false;
          status.textContent=root.dataset.error;
          if(script&&!customElements.get('elevenlabs-convai'))script.remove();
        }
        function ready(){
          if(settled)return;
          settled=true;
          clearTimeout(timeout);
          if(!document.getElementById('lb-elevenlabs-widget')){
            var widget=document.createElement('elevenlabs-convai');
            widget.id='lb-elevenlabs-widget';
            widget.setAttribute('agent-id',root.dataset.agentId);
            widget.setAttribute('variant','expanded');
            widget.setAttribute('dismissible','true');
            widget.setAttribute('avatar-orb-color-1','#d7e4cc');
            widget.setAttribute('avatar-orb-color-2','#a98247');
            widget.setAttribute('markdown-link-allowed-hosts','lukebattiloro.com,intro.co,elevenlabs.io');
            widget.setAttribute('markdown-link-allow-http','false');
            [['action-text','action'],['start-call-text','start'],['end-call-text','end'],['expand-text','expand'],['listening-text','listening'],['speaking-text','speaking']].forEach(function(pair){widget.setAttribute(pair[0],root.dataset[pair[1]])});
            document.body.appendChild(widget);
          }
          root.hidden=true;
        }
        timeout=setTimeout(fail,12000);
        if(customElements.get('elevenlabs-convai')){ready();return;}
        customElements.whenDefined('elevenlabs-convai').then(ready).catch(fail);
        if(!script){
          script=document.createElement('script');
          script.id='lb-elevenlabs-script';
          script.src='https://unpkg.com/@elevenlabs/convai-widget-embed';
          script.async=true;
          script.addEventListener('error',fail,{once:true});
          document.head.appendChild(script);
        }else{
          script.addEventListener('error',fail,{once:true});
        }
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){mount(document)},{once:true})}else{mount(document)}
  document.addEventListener('shopify:section:load',function(event){mount(event.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
